import { defineComponent as _defineComponent } from 'vue'
import { FireOutbreak } from '@/@core/fire-risk-dashboard/domain/entities/FireOutbreak'
import HighestFireOutbreakMarker from './HighestFireOutbreakMarker.vue'
import FireOutbreakMarker from './FireOutbreakMarker.vue'
import Tooltip from '@/components/ui/tooltip/Tooltip.vue'
import FireOutbreakTooltip from './FireOutbreakTooltip.vue'
import { nextTick, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomFireOutbreakMarker',
  props: {
    alert: null,
    focused: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	alert: FireOutbreak
	// true quando o foco foi selecionado na lista lateral e o mapa terminou o zoom
	focused?: boolean
};



const tooltipRef = ref<InstanceType<typeof Tooltip>>()

watch(
	() => props.focused,
	async (focused) => {
		if (!focused) return
		await nextTick()
		tooltipRef.value?.show()
	},
)

function getMarkerContainer(tippyInstance: any): HTMLElement | null {
	return tippyInstance.reference?.closest('.mapboxgl-marker') ?? null
}

const tooltipOptions = {
	trigger: 'click',
	onShow(instance: any) {
		const marker = getMarkerContainer(instance)
		if (marker) marker.style.zIndex = '10'
	},
	onHide(instance: any) {
		const marker = getMarkerContainer(instance)
		if (marker) marker.style.zIndex = ''
	},
}

return { __sfc: true,props, tooltipRef, getMarkerContainer, tooltipOptions, HighestFireOutbreakMarker, FireOutbreakMarker, Tooltip, FireOutbreakTooltip }
}

})